import type { ReactNode } from 'react';

/** A tab's one-line explanation, with its actions on the right. */
export function MaintenanceTabHeader({
  description,
  actions,
}: {
  description: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
      <p className="text-sm text-muted-foreground">{description}</p>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
